class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var threshold = 30000;
          var total = cart.total_price;
          var remaining = threshold - total;
          var pct = Math.min(Math.round((total / threshold) * 100), 100);
          document.querySelectorAll('.bcp-shipping-bar').forEach(function(bar) {
            var msg = bar.querySelector('.bcp-shipping-bar__message');
            var fill = bar.querySelector('.bcp-shipping-bar__fill');
            if (!msg || !fill) return;
            if (total >= threshold) {
              msg.innerHTML = 'You\'ve unlocked FREE Overnight Shipping!';
              msg.classList.add('bcp-shipping-bar__message--unlocked');
              fill.style.width = '100%';
            } else {
              msg.innerHTML = 'You\'re only <strong>$' + (remaining/100).toFixed(2) + '</strong> away from FREE Overnight Shipping!';
              msg.classList.remove('bcp-shipping-bar__message--unlocked');
              fill.style.width = pct + '%';
            }
          });
        });
      },
      { once: true }
    );
    document.body.addEventListener('click', this.onBodyClick);
  }
  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

